import axiosInstance from '../functions/axiosInstance';
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const acceptInvite = async (apiToken = null, inviteCode = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!inviteCode) {
        console.log("no inviteCode");
        return null;
    }
    //CALLING SERVER with acceptinvite")
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'acceptinvite',
            'apiToken': apiToken,
            'invitecode': inviteCode,
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from acceptinvite call");
    }).catch((error) => { console.log(error); });
};

export default acceptInvite;